const translation = {
  'url.about.accreditation': '/about/accreditation',
  'url.about.graduates': '/about/graduates',
  'url.about.graduates-2': '/about/graduates-2',
  'url.about.graduates-3-with-popup': '/about/graduates-3-with-popup',
  'url.about.index': '/about',
  'url.about.team': '/about/team',
  'url.about.what-is-tefl-and-how-does-it-work': '/about/what-is-tefl-and-how-does-it-work',
  'url.apply.how-to-make-a-good-application': '/apply/how-to-make-a-good-application',
  'url.apply.index': '/apply',
  'url.apply.terms': '/apply/terms',
  'url.apply.thank-you': '/apply/thank-you',
  'url.birthday-competition-terms-conditions.index': '/birthday-competition-terms-conditions',
  'url.birthday-competition-terms-conditions.thank-you':
    '/birthday-competition-terms-conditions/thank-you',
  'url.brexit-guide.index': '/brexit-guide',
  'url.brexit-guide.thank-you': '/brexit-guide/thank-you',
  'url.clases-de-ingles-economicas-barcelona.evening':
    '/clases-de-ingles-economicas-barcelona/evening',
  'url.clases-de-ingles-economicas-barcelona.index': '/clases-de-ingles-economicas-barcelona',
  'url.contact.index': '/contact',
  'url.contact.thank-you': '/contact/thank-you',
  'url.courses.dates.index': '/courses/dates',
  'url.courses.dates.special-offers': '/courses/dates/special-offers',
  'url.courses.one-month-160-hour-tefl-course.entry-requirements':
    '/courses/one-month-160-hour-tefl-course/entry-requirements',
  'url.courses.one-month-160-hour-tefl-course.index': '/courses/one-month-160-hour-tefl-course',
  'url.courses.developing-teacher-course': '/courses/developing-teacher-course',
  'url.courses.tefl-work-and-placement': '/courses/tefl-and-work-placement',
  'url.courses.tefl-adventure': '/courses/tefl-and-adventure',
  'url.teaching-kids-course': '/courses/teaching-kids-course',
  'url.courses.tefl-spanish': '/courses/tefl-and-spanish',
  'url.courses.faq': '/courses/faq',
  'url.courses.index': '/courses',
  'url.courses.online-trinity-certtesol-tefl-course':
    '/courses/online-trinity-certtesol-tefl-course',
  'url.courses.tefl-course-payment-plan': '/courses/tefl-course-payment-plan',
  'url.es.apply.evening.index': '/es/apply/evening',
  'url.es.apply.evening.gracias': '/es/apply/evening/gracias',
  'url.es.apply.gracias': '/es/apply/gracias',
  'url.es.apply.index': '/es/apply/',
  'url.guide-to-teaching-english-online.index': '/guide-to-teaching-english-online',
  'url.guide-to-teaching-english-online.thank-you': '/guide-to-teaching-english-online/thank-you',
  'url.newsletter.thank-you': '/newsletter/thank-you',
  'url.spanish-visa-guide-australian-citizens.index': '/spanish-visa-guide-australian-citizens',
  'url.spanish-visa-guide-australian-citizens.thank-you':
    '/spanish-visa-guide-australian-citizens/thank-you',
  'url.spanish-visa-guide-canadian-citizens.index': '/spanish-visa-guide-canadian-citizens',
  'url.spanish-visa-guide-canadian-citizens.thank-you':
    '/spanish-visa-guide-canadian-citizens/thank-you',
  'url.spanish-visa-guide-uk-citizens.index': '/spanish-visa-guide-uk-citizens',
  'url.spanish-visa-guide-uk-citizens.thank-you': '/spanish-visa-guide-uk-citizens/thank-you',
  'url.spanish-visa-guide-us-citizens.index': '/spanish-visa-guide-us-citizens',
  'url.spanish-visa-guide-us-citizens.thank-you': '/spanish-visa-guide-us-citizens/thank-you',
  'url.spanish-visa-guide-south-african-citizens.index':
    '/spanish-visa-guide-south-african-citizens',
  'url.spanish-visa-guide-south-african-citizens.thank-you':
    '/spanish-visa-guide-south-african-citizens/thank-you',
  'url.tefl-iberia-brochure.index': '/tefl-iberia-brochure',
  'url.gap-year-brochure.index': '/gap-year-brochure',
  'url.gap-year-brochure.thank-you': '/gap-year-brochure/thank-you',
  'url.tefl-iberia-brochure.thank-you-guide': '/tefl-iberia-brochure/thank-you-guide',
  'url.tefl-iberia-brochure.thank-you': '/tefl-iberia-brochure/thank-you',
  'url.tefl-iberia-free-ebook.index': '/tefl-iberia-free-ebook',
  'url.tefl-iberia-free-ebook.thank-you': '/tefl-iberia-free-ebook/thank-you',
  'url.web.privacy': '/web/privacy',
  'url.webinar.teaching-english-in-spain-after-brexit':
    '/webinar/teaching-english-in-spain-after-brexit',
  'url.webinar.tefl-coronavirus-everything-you-need-to-know':
    '/webinar/tefl-coronavirus-everything-you-need-to-know',
  'url.webinar.thank-you': 'webinar/thank-you',
  'url.working-as-a-teacher.careers-service': '/working-as-a-teacher/careers-service',
  'url.working-as-a-teacher.student-visas': '/working-as-a-teacher/student-visas',
  'url.working-as-a-teacher.work-with-us': '/working-as-a-teacher/work-with-us',
  'url.10th-birthday-course-giveaway': '/10th-birthday-course-giveaway',
  'url.accommodation': '/accommodation',
  'url.application-recieved': '/application-recieved',
  'url.blended-trinity-cert-tesol-course': '/blended-trinity-cert-tesol-course',
  'url.blog': '/blog',
  'url.course-order': '/course-order',
  'url.covid': '/covid',
  'url.guide-to-living-and-teaching-english-in-barcelona':
    '/guide-to-living-and-teaching-english-in-barcelona',
  'url.guide-to-living-and-teaching-english-in-seville':
    '/guide-to-living-and-teaching-english-in-seville',
  'url.index': '/',
  'url.subscribe': '/subscribe',
  'url.teaching-kids-course': '/teaching-kids-course',
  'url.tefl-guide': '/tefl-guide',
  'url.tefl-spanish-course-barcelona': '/tefl-spanish-course-barcelona',
  'url.tefl-teaching-resources': '/tefl-teaching-resources',
  'url.thank-you': '/thank-you',
  'url.gap-year-program': '/gap-year-program',
  'url.courses-faqs': '/courses/faq/',
};

module.exports = translation;
